import { type TooltipProps } from '@mui/material'

import { InfoTooltip } from './InfoTooltip'

export function SpokenTooltips({
  children,
  placement,
}: {
  children: React.ReactElement<any, any>
  placement?: TooltipProps['placement']
}) {
  return (
    <InfoTooltip
      placement={placement}
      title="Students record a response to a prompt. AI grades and provides feedback or you can review and score manually."
    >
      {children}
    </InfoTooltip>
  )
}
